import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { catchError, debounceTime, forkJoin, of, Subject, Subscription } from 'rxjs';
import { GtwElementsBaseUrlsModel } from '../shared/_models/gtw-elements-base-urls.model';
import { NavigationModel } from './navigation.model';
import { NavigationService } from './navigation.service';
import { ActiveScreensService } from '../shared/_services/active-screens.service';
import * as _ from 'lodash-es';
import { safeJsonInput } from '../shared/_utils/safe-json-input';
@Component({
    selector: 'gtw-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class NavigationComponent implements OnInit, OnDestroy {
  
  @Output('load-screens') showScreensEvent = new EventEmitter<any>();
  @Output('load-leftnav') loadleftNav = new EventEmitter<any>();

  
  private _baseUrlsReady = false;
  private _channelKeyReady = false;

  @Input('base-urls')
  set _base_urls(baseUrls: string){
    try{
      let urls:GtwElementsBaseUrlsModel = safeJsonInput<any>(baseUrls, null, 'navigation.parse1');
      if(Object.keys(urls).length > 0){
        this.baseURLs = urls;
        this._baseUrlsReady = true;
      }
    }catch(e){
      console.log("Input Not yet stable. Still waiting to get resolved.");
    }
  }

  @Input('channel-key')
  set _channel_key(keys : any){
    if (!keys) return;
    try{
      this.globalAppParams = safeJsonInput<any>(keys, null, 'navigation.parse2');
      this._channelKeyReady = true;
      this.tryInit();
    }catch(error){
      console.log("Not an valid object");
    }
  }

  private tryInit(): void {
    if (!this._baseUrlsReady || !this._channelKeyReady) return;
    this.init();
  }

  @Input("current-screen")
  set _curentScreen(currentScreen:any){
    try{
      this.currentScreen = safeJsonInput<any>(currentScreen, null, 'navigation.parse3');      
  }catch(error){
      console.log("Not a valid screen ");
    }
  }

  @Output('load-current-screen') showCurrentScreensEvent = new EventEmitter<any>();
  
  currentScreen!:any;
  channelKey:number = NaN;
  globalAppParams : any = {};
  baseURLs: GtwElementsBaseUrlsModel ={'admin':'/admin','api':'/gtw',"custom":'','efile':'','pdfEngine': '','bulkPdfEngine':''};
  appNavigation:any=[];

  isMenuPanelClosed=true;
  isAccordion1Open=false;
  isAccordion2Open=false;
  taskList:NavigationModel[]= [];
  domainName ='';
  categoriesList:Array<any> = [];

  originalCategoriesList:Array<any>=[];
  originalTaskList:Array<any>=[];
  private modelChanged: Subject<{list:any,searchText:string, type:'tax-type'|'categories'}> 
                  = new Subject<{list:any,searchText:string, type:'tax-type'|'categories'}>();
	debounceTime = 500;

  categoriesInDomain:any = {};
  taxTypeSearchTerm: string = '';
  categoriesSearchTerm: string = '';

  menuSettings = false;
  mSetting = {
    showScreen: true,
  }

  homePage:any = {};

  private readonly subs = new Subscription();

  constructor(private navigationService:NavigationService,
              private activeScreenService: ActiveScreensService) { }

  ngOnInit(): void {

    this.subs.add(
      this.modelChanged
        .pipe(
          debounceTime(this.debounceTime),
        )
        .subscribe((val) => {
          if(val.type == 'tax-type'){
            this.taskList = this.navigationService.filterBySearch(val.list, val.searchText,val.type);
          }else{
            this.categoriesList = this.navigationService.filterBySearch(val.list, val.searchText,val.type);
          }
        })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  init(){
    this.appNavigation = [];
    this.subs.add(
      forkJoin({
        appNavigation: this.navigationService.getUserNavigatorV2(this.baseURLs.api, this.globalAppParams),
        categories: this.navigationService.getAllCategories(this.baseURLs.admin).pipe(
          catchError(err => { console.warn('[Navigation] getAllCategories failed:', err); return of(null); })
        )
      })
      .subscribe((res:any)=>{
          this.setInitialState(res.appNavigation);
          this.appNavigation = res.appNavigation;

          let menuData = this.setTreeParent([this.navigationService.navObject],'children');
          this.activeScreenService.appNavigationList = this.appNavigation;
          this.navigationService.navObject = menuData;
          this.loadleftNav.emit(menuData);
      },
        (err:any)=>{
      })
    );
  }

  thisChildren:Array<any> = [];
  
  setTreeParent(_collection: any, _children:any){
    for(var i = 0;i<_collection.length;i++){
          
        this.thisChildren = _collection[i][_children];

        if (this.thisChildren && this.thisChildren.length) {
          _collection[i].children =  this.setParent(_collection[i],this.thisChildren, _children);
        }
    }
    return _collection;
  }
  thisMenu:Array<any> = [];
  setParent(_collection:any,data:any, _children:any){
    for(var i = 0;i<data.length;i++){
      this.thisMenu = data[i][_children];

      if(data[i].type == 'task'){
        data[i]['parent'] = _collection;
      }
      for(var ii in this.thisMenu){
        if(this.thisMenu[ii] !=undefined){
          this.thisMenu[ii]['parent'] = data[i];
          if (this.thisMenu[ii].type === 'activity' && this.thisMenu[ii].screens.length) {
            this.thisMenu[ii]['parent'] = data[i];
            var screens = this.thisMenu[ii].screens;
            for (var n in screens) {
                screens[n]['parent'] = this.thisMenu[ii];
            }
          }else if(this.thisMenu[ii].type == 'task'){
            this.thisMenu[ii] = iterateTask(this.thisMenu[ii],'children');            
          }
        }    
            
      }
      //SET SCREEN PARENT
        function iterateTask(_tasks: any,children: any){
           if(_tasks.type == 'task' && _tasks.children.length){
             var loopThroughTasks =  function(_taskData:any) {
                _.each(_taskData.children,function(ii,index){
                  if(ii.type == 'task'){
                     //
                     ii['parent'] = _taskData;
                      if(ii.children){
                        loopThroughTasks(ii);
                      }
                  }else{
                    if (ii.type === 'activity' && ii.screens.length) {
                      ii['parent'] = _taskData;
                      var screens = ii.screens;
                      for (var n in screens) {
                          screens[n]['parent'] = ii;
                      }
                    }
                  }
                });
             } 
              loopThroughTasks(_tasks);            
           }
           return _tasks;
        }           
      }
    return data;
  }

  showTasksAndCategories(selectedTaxType:{tasks:NavigationModel, domainName:string}) {
    this.isMenuPanelClosed = false;
    if((selectedTaxType.tasks.hasOwnProperty('children'))){
      if(this.categoriesInDomain.hasOwnProperty(selectedTaxType.domainName) ){
        this.categoriesList = this.categoriesInDomain[selectedTaxType.domainName];
      }else {
        this.categoriesInDomain[selectedTaxType.domainName] =
          this.navigationService.getAllCategoryScreens(selectedTaxType.tasks);;
        this.categoriesList = this.categoriesInDomain[selectedTaxType.domainName];
      }
      // this.categoriesList = this.navigationService.getAllCategoryScreens(selectedTaxType.tasks);
      this.taskList =  selectedTaxType.tasks.children;
    }
      //clone for backup
      this.originalTaskList = _.cloneDeep(selectedTaxType.tasks.children);//safeJsonInput<any>(JSON.stringify(selectedTaxType.tasks.children), null, 'navigation.parse4');
      this.originalCategoriesList = _.cloneDeep(this.categoriesList);//safeJsonInput<any>(JSON.stringify(this.categoriesList), null, 'navigation.parse5');
      this.domainName = selectedTaxType.domainName;
  }

  showScreens(screen : any){
    this.showScreensEvent.emit(screen);
    this.resetSearchState();
    this.isMenuPanelClosed = true;

  }

  closeMenuPanel(event:any){
    this.resetSearchState();
    this.isMenuPanelClosed = true;
  }

  private resetSearchState(): void {
    this.taxTypeSearchTerm = '';
    this.categoriesSearchTerm = '';
    this.isAccordion1Open = false;
    this.isAccordion2Open = false;

    if (this.originalTaskList && this.originalTaskList.length) {
      this.taskList = _.cloneDeep(this.originalTaskList);
    }
    if (this.originalCategoriesList && this.originalCategoriesList.length) {
      this.categoriesList = _.cloneDeep(this.originalCategoriesList);
    }
  }

  onAppkitSearch(
    event: { originEvent?: any; queryStr?: string; queryString?: string; target?: { value?: string } },
    type: 'tax-type'|'categories'
  ): void {
    const query = (event?.queryStr
      ?? event?.queryString
      ?? event?.target?.value
      ?? (type === 'tax-type' ? this.taxTypeSearchTerm : this.categoriesSearchTerm)
      ?? ''
    ).toString();
    this.filterScreen({ target: { value: query } }, type);
  }

  onAppkitClear(type: 'tax-type'|'categories'): void {
    if (type === 'tax-type') {
      this.taxTypeSearchTerm = '';
    } else {
      this.categoriesSearchTerm = '';
    }
    this.filterScreen({ target: { value: '' } }, type);
  }

  filterScreen(event:any,type:'tax-type'|'categories'){
    const searchText = (event?.target?.value ?? '').toString();

    if(type == 'categories'){
      let tempList = _.cloneDeep(this.originalCategoriesList);//safeJsonInput<any>(JSON.stringify(this.originalCategoriesList), null, 'navigation.parse6');
      this.modelChanged.next({list:tempList, searchText: searchText,type:type});
      this.isAccordion2Open= (searchText.length > 0)?true:false;
    }else{
      let tempList = _.cloneDeep(this.originalTaskList);//safeJsonInput<any>(JSON.stringify(this.originalTaskList), null, 'navigation.parse7');
      this.modelChanged.next({list:tempList, searchText: searchText,type:type});
      this.isAccordion1Open= (searchText.length > 0)?true:false;
    }
  }

  toggleAccordion(index:number){
    if(index == 1){
      this.isAccordion1Open = this.isAccordion1Open ? false : true;
    }
    if(index == 2){
      this.isAccordion2Open = this.isAccordion2Open ? false : true;
    }
  }

  switch(status: any) {
    this.mSetting.showScreen = !this.mSetting.showScreen;
  }

  setInitialState(navData:any){
    let filteredScreen = this.navigationService.getCurrentScreen(this.currentScreen);
    if(filteredScreen.length != 0){
      if(this.globalAppParams.channel == 1060 || navData && navData[0].id == 5741){ // DST
        this.showCurrentScreensEvent.emit({  
          // state: 'workspace.dst-home-page',
          // url: '/workspace/dst-home-page',
          // screen: {activity_key: "7595",screen_key: "11396"}
          state: 'workspace.modules',
          url: '/workspace/modules',
          screen: filteredScreen[0]  
        })  
      }else{
        this.showCurrentScreensEvent.emit({  
          state: 'workspace.modules',
          url: '/workspace/modules',
          screen: filteredScreen[0]  
        })   
      }        
    }
    // this.activeScreenService.markOpenSelectedScreen(filteredScreen[0]);
  }
}
